import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {UpdateWorkflowRequest, UpdateWorkflowResponse} from './contracts'

export async function apiUpdateWorkflow(body: UpdateWorkflowRequest): Promise<UpdateWorkflowResponse> {
  const apiData = getApiMetadata('memex-workflow-update-api-data')

  const {data} = await fetchJSON<UpdateWorkflowRequest, UpdateWorkflowResponse>(apiData.url, {
    method: 'PUT',
    body,
    token: apiData.token,
  })

  return data
}
